// Screenshot Modal Controller
// Handles clicking screenshots to open them in a modal

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static classes = ["hidden"];
  static targets = ["modal", "image"];

  connect() {
    // Use event delegation to handle clicks on any screenshot button
    this.element.addEventListener("click", this.handleClick.bind(this));
    this.boundKeyHandler = this.handleKeyup.bind(this);
  }

  disconnect() {
    this.element.removeEventListener("click", this.handleClick.bind(this));
    document.removeEventListener("keydown", this.boundKeyHandler);
  }

  handleClick(event) {
    const button = event.target.closest("[data-screenshot]");

    if (button) {
      event.preventDefault();
      this.open(button.dataset.screenshot);
    }

    // Close modal when clicking the close button or backdrop
    if (
      event.target === this.modalTarget ||
      event.target.closest("[data-action*='close']") ||
      event.target.classList.contains("fixed") // clicking backdrop
    ) {
      this.close();
    }
  }

  handleKeyup(event) {
    if (
      event.key === "Escape" &&
      !this.modalTarget.classList.contains(this.hiddenClass)
    ) {
      this.close();
    }
  }

  open(imageUrl) {
    this.imageTarget.src = imageUrl;
    this.modalTarget.classList.remove(this.hiddenClass);
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", this.boundKeyHandler);

    // Track screenshot view
    this.trackScreenshotView(imageUrl);
  }

  trackScreenshotView(imageUrl) {
    // Get project info from parent controller if available
    const projectTracking = this.element.closest(
      "[data-controller='project-tracking']",
    );
    const projectId = projectTracking?.dataset?.projectId;
    const projectName = projectTracking?.dataset?.projectName;

    // Extract screenshot index from URL if possible
    const match = imageUrl.match(/screenshot[_-]?(\d+)/i);
    const screenshotIndex = match ? parseInt(match[1], 10) + 1 : null;

    if (typeof window.analytics?.track === "function") {
      window.analytics.track("screenshot_viewed", {
        project_id: projectId,
        project_name: projectName,
        screenshot_index: screenshotIndex,
        url: imageUrl,
        timestamp: new Date().toISOString(),
      });
    }
  }

  close() {
    this.modalTarget.classList.add(this.hiddenClass);
    document.body.style.overflow = "";
    document.removeEventListener("keydown", this.boundKeyHandler);
  }
}
